import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../support/with_presenter';
import {EventListPresenter} from './EventListPresenter';
import {ExpandedPart} from '../../../business/expanded_parts/ExpandedPartsProvider';
import {Title} from './components/Title';
import {Icon} from './components/Icon';
import {AddEventWizard} from './AddEventWizard/AddEventWizard';
import {AddChapterWizard} from './AddChapterWizard/AddChapterWizard';

interface OwnProps {
    expandedPart: ExpandedPart;
    hasChapter: boolean;
}

const EventListComponent: FunctionComponent<OwnProps & PresenterProps<EventListPresenter>> = observer(
    ({expandedPart, hasChapter, presenter}) => {
        return (
            <div className="event-list">
                <div className="event-list__content">
                    {presenter.events.map((event) => {
                        return (
                            <div key={event.__uuid} className="event">
                                <div className="event__icon">
                                    <Icon eventType={event.type} />
                                </div>
                                <Title event={event} />
                                <button
                                    className="event__trash ion-md-trash"
                                    onClick={() => presenter.onTrashEvent(event)}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className="event-list__footer">
                    {!hasChapter && (
                        <button
                            className="btn btn-secondary ion-ios-add icon-left pull-right"
                            onClick={() => presenter.onAddChapterClick()}
                        >
                            Insert chapter
                        </button>
                    )}
                    <button
                        className="btn btn-secondary ion-ios-add icon-left pull-right"
                        onClick={() => presenter.onAddEventClick()}
                    >
                        Add event
                    </button>
                    {presenter.addEventWizardVisible && (
                        <AddEventWizard
                            expandedPart={expandedPart}
                            onAdd={(partEvent) => presenter.onAddEvent(partEvent)}
                            onCancel={() => presenter.onCancelAddEventWizard()}
                        />
                    )}
                    {presenter.addChapterWizardVisible && (
                        <AddChapterWizard
                            expandedPart={expandedPart}
                            onAdd={(chapter) => presenter.onAddChapter(chapter)}
                            onCancel={() => presenter.onCancelAddChapterWizard()}
                        />
                    )}
                </div>
            </div>
        );
    },
);

export const EventList = withPresenter<EventListPresenter, OwnProps>(
    (props, component) =>
        new EventListPresenter(props.expandedPart.__uuid, component.eventInteractor, component.chaptersInteractor),
    EventListComponent,
);
